export const getProducts = '/products';
export const getProductDetail = '/products/get-product-details/';
export const addProduct = '/products/addProduct';
export const updateProduct = '/products/';
export const deleteProduct = '/products/';
export const generateLink = '/deep-link/generate';
